import {
  Backdrop,
  Card,
  CardContent,
  CardHeader,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { productHistoryRequest, getTasksRequest } from 'src/store/actions';

import { useHistory } from 'react-router';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  listItem: {
    cursor: 'pointer'
  },
  inner: {
    minWidth: 1150
  },
  methodCell: {
    width: 100
  },
  statusCell: {
    width: 64
  },
  baslik: {
    padding: theme.spacing(1)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}));

function Tarihce({
  className,
  UrunData,
  productHistoryReducer,
  productHistoryRequest,
  getTasksRequest,
  setProductHistoryDialog
}) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const history = useHistory();

  useEffect(() => {
    productHistoryRequest(UrunData);
    // eslint-disable-next-line
  }, [])

  const SetWorkOrderDetail = (event, row) => {
    getTasksRequest(row.WorkOrderId);
    setProductHistoryDialog(false);
    history.push(`/WorkOrder/${row.WorkOrderId}/summary`);
  };

  return (
    <div className={clsx(classes.root, className)}>
      <Card>
        <CardHeader title={t('urun_tarihce')} />
        <Divider />
        <CardContent className={classes.content}>
          {productHistoryReducer.loading ? (
            <Backdrop
              className={classes.backdrop}
              open={productHistoryReducer.loading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          ) : (
            <div />
          )}
          <List className={classes.root}>
            {productHistoryReducer.data.map(log => (
              <div
                key={log.OperationDate}
                className={classes.listItem}
                onClick={e => SetWorkOrderDetail(e, log)}
              >
                <ListItem alignItems="flex-start">
                  <ListItemText
                    secondary={
                      <>
                        <Typography
                          component="span"
                          variant="body1"
                          className={classes.inline}
                          color="textPrimary"
                        >
                          {log.Year === undefined ? '' : log.Day + ' ' + log.Month + ' ' + log.Year + ' ' + log.Hour}
                          <br />
                          {'WC: ' + log.WorkCaseId + '-' + log.Status}
                          <br />
                          {'WO: ' + log.WorkOrderId}
                          <br />
                          {t('lblRepairedBy') + ' : ' + log.ServiceShop}
                          <br />
                          {t('Basvuru_Nedeni') + ' : ' + log.Issue}
                          <br />
                          {t('Garanti_tip') + ' : ' + log.WarrantyType}
                          <br />
                          {t('lblDefectDescription') + ' : ' + log.DefectDesc}
                          <br />
                          {t('lblMaterialDescription') + ' : ' + log.MaterialDesc}
                          <br />
                          {t('lblRepairDate') + ' : ' + log.OperationDate}
                          <br />
                        </Typography>

                      </>
                    }
                  />
                </ListItem>

                <Divider variant="inset" component="li" />
              </div>
            ))}
          </List>
        </CardContent>
      </Card>
    </div>
  );
}

Tarihce.propTypes = {
  className: PropTypes.string
};

export default connect(
  state => ({
    productHistoryReducer: state.productHistoryReducer
  }),
  {
    productHistoryRequest,
    getTasksRequest
  }
)(Tarihce);
